import type { ColumnConfig } from '@/shared/types/table';

/** Columna de acciones (`type: 'actions'`): sticky a la derecha, no participa en fijado izquierdo. */
export function isActionsColumn<T>(column: ColumnConfig<T>): boolean {
  return column.type === 'actions';
}

/**
 * Si la columna puede mostrar el control de fijar/bloquear y alternar `locked`.
 * Resuelve `column.lockable` explícito frente al valor por tabla (`columnsLockable`).
 * Las columnas `actions` nunca son bloqueables (aunque `lockable: true` o `locked: true`).
 */
export function isColumnLockable<T>(
  column: ColumnConfig<T>,
  tableColumnsLockable?: boolean
): boolean {
  if (isActionsColumn(column)) {
    return false;
  }
  const tableAllows = tableColumnsLockable !== undefined ? tableColumnsLockable : true;
  return column.lockable !== undefined ? column.lockable : tableAllows;
}

/**
 * Si la columna muestra el control de resize (handle en cabecera).
 * Las columnas `actions` nunca son redimensionables; tampoco si `resizable: false`, tabla sin resize o `locked`.
 */
export function isColumnResizable<T>(column: ColumnConfig<T>, tableResizable: boolean): boolean {
  if (!tableResizable) {
    return false;
  }
  if (isActionsColumn(column)) {
    return false;
  }
  if (column.resizable === false) {
    return false;
  }
  if (column.locked) {
    return false;
  }
  return true;
}

/** Quita `locked` en columnas de acciones (p. ej. config persistida antigua). */
export function sanitizeActionsColumnLockState<T>(columns: ColumnConfig<T>[]): ColumnConfig<T>[] {
  return columns.map((col) =>
    isActionsColumn(col) && col.locked ? { ...col, locked: false } : col
  );
}
